import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

import ConfirmationCard from '../../components/Shared/ConfirmationCard';
import { Title } from '../../components/Shared/TitleSuccess';

import { StatesAbbreviation, ActionTypes } from '../../utils/enums';

const TitleComponent = () => <Title>Congrats on choosing to register to vote.</Title>;

TitleComponent.propTypes = {};

const VoteRegistrationSuccess = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            thankYouText={props.thankYouText}
            titleComponent={<TitleComponent />}
            hideSubtitle={true}
            {...props}
        />
    </TransitionContainerNoExit>
);

VoteRegistrationSuccess.propTypes = {
    thankYouText: PropTypes.string.isRequired
};

export default connect(
    state => ({
        thankYouText: `The ${
            StatesAbbreviation[state.voteRegistration.formData.stateId]
            } state website will let you register completely online!`
    }),
    {},
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.VoteRegistration)
                return true;

            return next === prev;
        }
    }
)(VoteRegistrationSuccess);
